export default class Layout {
    constructor(pageClass = 'page') {
        this.pageClass = pageClass;
        this.header = document.querySelector('[data-layout="header"]');
        this.scrollUp = document.querySelector('[data-layout="scroll-up"]');
        this.menu = document.querySelector('[data-menu="menu"]');
        this.menuToggleBtn = document.querySelectorAll('[data-menu="toggle"]');
        this.menuLinks = document.querySelectorAll('[data-menu="list"] a');
        this.images = document.querySelectorAll('img');
        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            document.documentElement.classList.add(this.pageClass);
            this.fixHeader();
            this.showScrollUp();
            this.initListeners();
        });
    }

    toggleMenu() {
        document.documentElement.classList.toggle('_lock');
        this.menuToggleBtn?.forEach(el => el.classList.toggle('_active'));
        this.menu?.classList.toggle('_active');
    }

    fixHeader() {
        this.header?.classList.toggle('_fixed', window.scrollY > 60);
    }

    showScrollUp() {
        this.scrollUp?.classList.toggle('_canScrollUp', window.scrollY > 800);
    }

    imgLoaded(img) {
        img.classList.add('_loaded');
    }

    initListeners() {
        window.addEventListener('scroll', () => {
            this.fixHeader();
            this.showScrollUp();
        });

        this.menuToggleBtn?.forEach(btn => btn.addEventListener('click', () => this.toggleMenu()));
        this.menuLinks?.forEach(link => link.addEventListener('click', () => this.toggleMenu()));

        this.scrollUp?.addEventListener('click', () =>
            setTimeout(() => window.scrollTo({top: -100, behavior: 'smooth'}), 100)
        );

        this.images?.forEach(img => {
            img.complete ? this.imgLoaded(img) : img.addEventListener('load', () => this.imgLoaded(img));
        });
    }
}
